export default __webpack_public_path__ + "static/media/hero-architecture.5ae35499.png";